import { render } from "./AgentTabItem.vue?vue&type=template&id=3ffa1135"
import script from "./AgentTabItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentTabItem.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/containers/popup/components/AgentTabItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ffa1135"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ffa1135', __exports__)) {
    api.reload('3ffa1135', __exports__)
  }
  
  module.hot.accept("./AgentTabItem.vue?vue&type=template&id=3ffa1135", () => {
    api.rerender('3ffa1135', render)
  })

}


export default __exports__